/**
 *  Extracts the filename from the content disposition header
 *  Content-Disposition: attachment; filename="example.json" => example.json
 */
export function extractFilenameFromContentDisposition(contentDisposition) {
    const regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = regex.exec(contentDisposition);
    if (matches != null && matches[1]) {
        return matches[1].replace(/['"]/g, '');
    }
}
/**
 * Fetches a produced export file from its (signed) URL and triggers a browser download.
 * Shared by the async export job's "Download" action and the synchronous export hook.
 */
export async function downloadFromSignedUrl(signedUrl, fallbackFileName = 'exported_file') {
    const urlParts = signedUrl.split('?')[0].split('/');
    const rawFilename = urlParts[urlParts.length - 1] || '';
    const filepath = decodeURIComponent(rawFilename) || '';
    const fileName = filepath.split('/').pop() || fallbackFileName;
    const response = await fetch(signedUrl, { credentials: 'omit' });
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const anchorElement = document.createElement('a');
    anchorElement.href = blobUrl;
    anchorElement.download = fileName;
    anchorElement.style.display = 'none';
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
    window.URL.revokeObjectURL(blobUrl);
}
export function downloadFile(response) {
    const href = window.URL.createObjectURL(response.data);
    const anchorElement = document.createElement('a');
    anchorElement.href = href;
    const contentDisposition = response.headers['content-disposition'];
    let fileName = 'strings.json';
    if (contentDisposition) {
        fileName = extractFilenameFromContentDisposition(contentDisposition) || fileName;
    }
    anchorElement.download = fileName;
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
    window.URL.revokeObjectURL(href);
}
